/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useEffect } from 'react';
import { notificationsPageSelectors } from '../../../../../../app/page/page-storage/notifications/notifications.selectors';
import { useSelect } from '../../../../../../utils/selector.utils';
import { useToggler } from '../../../../../../utils/toggler.utils';
import { Notification } from './Notification';
import { notificationSelectors } from '../../../../../../app/resource/notification/notification.selectors';
import { INotificationsProps } from './types';
import { useDispatch } from 'react-redux';
import {
  storeUnseenCount,
  updateNotificationsStatus,
} from '../../../../../../app/page/page-storage/notifications/notifications.actions';

export const Notifications: FunctionComponent<INotificationsProps> = ({ meetingId }) => {
  const dispatch = useDispatch();
  const [isToggledPanel, handleTogglePanel] = useToggler();

  const notifications = useSelect(notificationSelectors.selectResourceList);
  let myNotifications = notifications;

  if (meetingId) {
    myNotifications = myNotifications.filter((notif) => notif.meetingId === meetingId);
  }

  myNotifications = myNotifications.sort((a, b) => (b?.createdAt ?? '').localeCompare(a?.createdAt ?? ''));

  const unseenNotificatonsCount = myNotifications.filter((item) => item.status === 'sent').length;
  const unseenCount = useSelect(notificationsPageSelectors.selectUnseenCount);

  useEffect(() => {
    dispatch(storeUnseenCount(unseenNotificatonsCount));
  }, [isToggledPanel, dispatch, unseenCount, unseenNotificatonsCount]);

  const handleNotifications = () => {
    const notificationsIds = myNotifications.filter((item) => item.status === 'sent').map((noti) => noti.id);
    dispatch(updateNotificationsStatus(notificationsIds, 'read'));
    handleTogglePanel();
  };

  return (
    <li className={`dropdown ${!isToggledPanel ? 'opened' : ''}`}>
      <a style={{ cursor: 'pointer' }} className="panel-button dropdown-button" onClick={handleNotifications}>
        <i className="icon-bell"></i>{' '}
        {unseenCount && (
          <span className="badge" style={{ width: 'auto', color: 'red', background: 'none' }}>
            {unseenCount}
          </span>
        )}
      </a>
      <ul className="dropdown-menu notification-menu drop-right" onMouseLeave={handleTogglePanel}>
        {myNotifications.map((notification) => (
          <li key={notification.id}>
            <Notification notification={notification} />
          </li>
        ))}

        <li className="view-all">
          <a>View All Notifications</a>
        </li>
      </ul>
    </li>
  );
};
